import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';  

import {
  BrowserRouter as Router,
  Route,
  Link,
  Routes,
  Navigate
} from "react-router-dom";

import Index from './Pages';

function App() {
  return (
    <div className="App">
       <Router>  
        <Routes> 
            // /faire-un-don
            // homepage  : https://assocsaintemarthe.org/faire-un-don/react-payment
            <Route path="/faire-un-don"  index element={<Index />} />
  
        </Routes> 
    </Router>
    </div>
  );
}

export default App;
